import React, { useCallback } from 'react';
import styled from 'styled-components';

import SelectableCard from 'shared/components/SelectableCard';

import { OptionComponentProps } from '../types';

const StyledSelectableCard = styled(SelectableCard)`
  && {
    box-shadow: none;
  }
`;

const TransformationOption = ({
  option,
  isSelected,
  onSelect,
}: OptionComponentProps) => {
  const handleCardSelection = useCallback((selected) => {
    onSelect(option, selected);
  }, [option, onSelect]);

  return (
    <StyledSelectableCard
      label={option}
      isSelected={isSelected}
      onSelect={handleCardSelection}
    />
  );
};

export default TransformationOption;
